import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from './en/translation.json';
import translationEs from './es/translation.json';
import translationMs from './ms/translation.json';
import translationSw from './sw/translation.json';
import translationPt from './pt/translation.json';
import translationHi from './hi/translation.json';
import translationId from './id/translation.json';
import translationTh from './th/translation.json';
import translationFil from './fil/translation.json';

function getLang() {
  const lang = window.navigator.language || 'en';
  // const lang = localStorage.getItem('lang') || 'en';

  if (lang.includes('es')) {
    return 'es';
  }
  if (lang.includes('ms')) {
    return 'ms';
  }
  if (lang.includes('sw')) {
    return 'sw';
  }
  if (lang.includes('pt')) {
    return 'pt';
  }
  if (lang.includes('id')) {
    return 'id';
  }
  if (lang.includes('hi')) {
    return 'hi';
  }
  if (lang.includes('th')) {
    return 'th';
  }
  if (lang.includes('tl') || lang.includes('fil')) {
    return 'fil';
  }

  return 'en';
}
const lang = getLang();

i18next.use(initReactI18next).init({
  lng: lang, //localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en', // if you're using a language detector, do not define the lng option
  // debug: true,
  fallbackLng: 'en',
  resources: {
    en: {
      translation,
    },
    es: {
      translation: translationEs,
    },
    ms: {
      translation: translationMs,
    },
    sw: {
      translation: translationSw,
    },
    pt: {
      translation: translationPt,
    },
    id: {
      translation: translationId,
    },
    hi: {
      translation: translationHi,
    },
    th: {
      translation: translationTh,
    },
    fil: {
      translation: translationFil,
    },
  },

  // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
  // set returnNull to false (and also in the i18next.d.ts options)
  // returnNull: false,
});
